import clsx from "clsx";
import styles from "./styles.scss";
import { AvatarLoadManager } from "@/components";
import { DEFAULT_DATE_FORMAT, NO_VALUE, RequestStatus } from "@/constants";
import { isValid } from "date-fns/isValid";
import { format } from "date-fns";
import { SidebarItemProps } from "@/pages/inbox/components/sidebar/types";
import { FC } from "react";
import { InboxItem } from "@/services/api/inbox/contracts";

const getRequestId = (item: InboxItem) => {
  if (item.RequestStatus === RequestStatus.Draft) {
    return item.ReferenceNumber;
  }

  return item.RequestId || item.ReferenceNumber;
};

export const SidebarItem: FC<SidebarItemProps> = ({
  ReferenceNumber,
  item,
  onSelectRequest,
}) => {
  if (!item) {
    return null;
  }

  const id = getRequestId(item);

  return (
    <li
      className={clsx(
        styles.listItem,
        ReferenceNumber === item.ReferenceNumber && styles.isActive,
      )}
      onClick={() => onSelectRequest(item)}
    >
      <AvatarLoadManager name={item.CreatedByName ?? NO_VALUE} />
      <div className={styles.itemInfo}>
        <span className={styles.itemInfoName}>{item.CreatedByName}</span>
        <span className={styles.itemInfoStatus}>{item.RequestStatus}</span>
        <span className={styles.itemInfoCompany}>{item.CompanyName}</span>
      </div>
      <div className={styles.itemInfoDate}>
        {isValid(new Date(item.UpdatedDate))
          ? format(new Date(item.UpdatedDate), DEFAULT_DATE_FORMAT)
          : NO_VALUE}
      </div>
      {!!id && <span className={styles.itemInfoReferenceNumber}>ID: {id}</span>}
    </li>
  );
};
